export default __webpack_public_path__ + "static/media/login-bg3.b853a761.png";